/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy } from './get-monthly-card-transactions-for-the-organization200-response-merged-transaction-detail-list-inner-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors } from './get-monthly-card-transactions-for-the-organization200-response-merged-transaction-detail-list-inner-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer } from './get-monthly-card-transactions-for-the-organization200-response-merged-transaction-detail-list-inner-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy } from './get-monthly-card-transactions-for-the-organization200-response-merged-transaction-detail-list-inner-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy } from './get-monthly-card-transactions-for-the-organization200-response-merged-transaction-detail-list-inner-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings } from './get-monthly-card-transactions-for-the-organization200-response-merged-transaction-detail-list-inner-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
 */
export interface GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetMonthlyCardTransactionsForTheOrganization200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];


